const hhmm = (iso: string): string =>
    new Date(iso).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' });

/**
 * Text zalohy pro admin detail udalosti (spec § 5.4). Casy prichazeji jako Instant s `Z`
 * a zobrazuji se v lokalni zone prohlizece.
 */
export function popisZalohy(o: { zalohaAktivni?: boolean; zalohaOd?: string | null; zalohaKonec?: string | null }): string | null {
    if (!o.zalohaOd) return null;
    if (o.zalohaAktivni === true) return `záloha od ${hhmm(o.zalohaOd)}`;
    if (o.zalohaKonec) return `byl v záloze ${hhmm(o.zalohaOd)}–${hhmm(o.zalohaKonec)}`;
    return null;
}
